import { registerGA } from '../../api/googleAnalyticsService';


function registerGoogleAnalytics(params){

    registerGA(params).then();
    
}

const googleAnalyticsActions = {
    registerGoogleAnalytics
};

export default googleAnalyticsActions;